import { c as _c } from "react/compiler-runtime";
import { Box, VStack } from '@chakra-ui/react';
import { ReactNode } from 'react';
export const SectionScroll = t0 => {
  const $ = _c(4);
  const {
    children,
    maxWidth: t1
  } = t0;
  const maxWidth = t1 === undefined ? "5xl" : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      base: 5,
      md: 8
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== children || $[2] !== maxWidth) {
    t3 = <Box height="full" overflowY="auto" width="full"><VStack align="stretch" gap={4} marginX="auto" maxWidth={maxWidth} padding={t2}>{children}</VStack></Box>;
    $[1] = children;
    $[2] = maxWidth;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};